import { use } from 'react';

import { invariant } from '@/app/utils/invariant';
import { AuthContext } from '@/common/contexts/auth-context';

export const useAuth = () => {
  const context = use(AuthContext);

  invariant(Boolean(context), 'useAuth must be in AuthProvider');

  return context;
};
